import React, { useState, useEffect, useRef } from "react";

export default function PasswordModal(props) {
  const ref = useRef();
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);

  // Use the current status from props
  const currentStatus = props.currentStatus;
  const token = props.csrfToken;

  const cleanup = () => {
    setPassword('');
    setError(null);
    props.onClose();
  };

  const hide = () => {
    $(ref.current).modal("hide");
  };

  useEffect(() => {
    const modal = $(ref.current);
    $(modal).on("hidden.bs.modal", cleanup);
    if (props.open) {
      modal.modal("show");
    } else {
      modal.modal("hide");
    }
    return () => modal.off("hidden.bs.modal", cleanup);
  }, [props.open]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);

    try {
      const response = await fetch('/users/update_mfa', {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': token,
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          user: {
            current_password: password
          }
        })
      });

      const data = await response.json();

      if (response.ok) {
        props.onStatusChange(!currentStatus);
        hide();
      } else {
        setError(data.error || 'An unexpected error occurred');
      }
    } catch (err) {
      setError('An unexpected error occurred');
    }
  };

  return (
    <div ref={ref} className='modal'>
      <div className='user-settings-password-modal'>
        <div className="header text-left no-left-padding">
          <i class="fa-thin fa-shield-exclamation"></i>
          <h2>confirm password</h2>
        </div>
        <p className='title'>
          To continue, please confirm your current password.
        </p>
        <p className='subtitle'>
          current password
        </p>
        <div style={{ position: 'relative' }}>
          <i className="fa-light fa-lock input-icons"></i>
          <input
            type="password"
            className="form-control"
            placeholder="enter password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            name="user[current_password2]"
            id="current_password2"
            autoComplete="current-password"
          />
        </div>
        {error && (
          <div className="text-danger" style={{ color: 'red', marginTop: '10px' }}>
            {error}
          </div>
        )}
        <div className='buttons'>
          <button className='btn-link cancel-link' onClick={hide}>cancel</button>
          <button
            className={`btn-base btn-${!password ? 'disabled' : 'green-stroke'}`}
            disabled={!password}
            onClick={handleSubmit}
          >
            continue
          </button>
        </div>
      </div>
    </div>
  );
}
